import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { dynamicUrl } from './Function';
import { Card, Placeholder } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
const Sitemap = () => 
{
    const { t } = useTranslation();
    const appLanguage = (localStorage.getItem('appLanguage') === null) ? 'en' : localStorage.getItem('appLanguage');
    const [isLoading, setLoading] = useState(true);
    const [SitemapList, setSitemapList] = useState([]);
    const fetchSubMenus = useCallback(async (menuId) => 
    {
        const response = await fetch(global.config.API_URL + "menu/subMenu/" + menuId);
        const subMenus = await response.json();
        const subMenusWithChildren = await Promise.all(subMenus.map(async (subMenu) => {
            const children = await fetchSubMenus(subMenu.sp_id);
            return { ...subMenu, subMenus: children };
        }));
        return subMenusWithChildren;
    }, []);

    useEffect(() => {
        const GetSitemapList = async () => 
        {
            setLoading(true);
            try 
            {
                const response = await fetch(global.config.API_URL + "menu/allMenu");
                const result = await response.json();
                const resultWithSubmenus = await Promise.all(result.map(async (menuItem) => {
                    const subMenus = await fetchSubMenus(menuItem.sp_id);
                    return { ...menuItem, subMenus };
                }));
                setSitemapList(resultWithSubmenus);
                setLoading(false);
                if (global.config.IsPrint === true) { console.info('SitemapList : Result', resultWithSubmenus); }
            } 
            catch (error) 
            {
                console.error('SitemapList : Error', error.message);
            }
        };
        GetSitemapList();
    }, [fetchSubMenus]);
    const renderMenuItems = (menuItems) => {
        return menuItems.filter(sp => sp.sp_id !== 246).map((sp, index) => (
            <li key={index} data-aos="flip-up" data-aos-duration="1000">
                <NavLink to={dynamicUrl(sp)} aria-label={( appLanguage === 'hi' && sp.sp_name_hi ) ? sp.sp_name_hi : sp.sp_name}>
                    {( appLanguage === 'hi' && sp.sp_name_hi ) ? sp.sp_name_hi : sp.sp_name }
                </NavLink>
                {sp.subMenus && sp.subMenus.length > 0 && (
                    <ul>
                        {renderMenuItems(sp.subMenus)}
                    </ul>
                )}
            </li>
        ));
    };

    return (
        <Card>
            <Card.Header className='text-center fs-3 text-uppercase'>{t('Sitemap')}</Card.Header>
            <Card.Body>
                <nav aria-label="Sitemap">
                    {isLoading ? (
                        <ul>
                            {[...Array(50)].map((_, index) => (
                                <React.Fragment key={index}>
                                <li data-aos="flip-up" data-aos-duration="1000">
                                    <Placeholder xs={9} />
                                </li>
                                <li data-aos="flip-up" data-aos-duration="1000">
                                    <Placeholder xs={7} />
                                </li>
                                <li data-aos="flip-up" data-aos-duration="1000">
                                    <Placeholder xs={11} />
                                </li>
                                </React.Fragment>
                            ))}
                        </ul>
                    ) : (
                        <ul className='text-start'>
                            <li data-aos="flip-up" data-aos-duration="1000">
                                <NavLink to="/">{t('Home')}</NavLink>
                            </li>
                            {renderMenuItems(SitemapList)}
                        </ul>
                    )}
                </nav>
            </Card.Body>
        </Card>
    );
}

export default Sitemap;
